/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable babel/camelcase */

import { client } from "venuescanner-js/services/socketClient";
import consume from "./models/consume";
import { onStore } from "./models/store";
const threads = ({ inboxService, states }) => {
  /**
   * @typedef {Object} threadPreview - Object containing abridged associated thread models
   * @property {Object} thread - Thread data according to the inbox schema
   * @property {Object} admin_thread_info - Admin thread info data according to the inbox schema
   * @property {Object} admin_event - Admin event data according to the inbox schema
   * @property {Object} space - Space data according to the inbox schema
   * @property {Object} venue - Venue data according to the inbox schema
   * @property {Object} host - Host data according to the inbox schema
   * @property {Object} organiser - Organiser data according to the inbox schema
   */

  /**
   * @typedef {Object} filter - Object containing optional filter params
   * @property {String} [sort='created_at'] - The total count of filtered threads
   * @property {String} [status='NEW'] - The Inbox status
   * @property {Integer} [limit=20] - The amount of records to fetch
   * @property {Integer} [skip=0] - The amount of records to skip
   */

  return {
    /** @function
     * @async
     * @name threads.fetch
     * @desc Fetches thread previews according to a filter
     * @memberof! module:inboxService
     * @param {Object} options
     * @param {String[]} [options.venueIds] - An array of Venue IDs, to check the threads across
     * @param {filter} [options.filter] - An object of filter definitions
     * @param {String} [options.ensureThread] - A thread ID to ensure is in the results returned (used when the thread has been loaded according to the URL param)
     * @param {Boolean} [options.more] - Indicates that the server is to return the next set of threads
     * @returns {threadPreview[]}
     */
    fetch: async function ({ venueIds, filter, ensureThread, more }) {
      // try {
      const clearLoaded =
        states.filter &&
        states.filter.status &&
        filter.status &&
        JSON.stringify(states.filter.status) !== JSON.stringify(filter.status);
      if (clearLoaded) states.loaded.thread_preview = [];
      states.filter = filter;
      const data = await client.sendPromise("room", {
        getThreads: { venueIds, filter: states.filter, ensureThread, more },
      });

      Object.keys(data).forEach((modelName) => {
        data[modelName] = consume(modelName, data[modelName]);
      });
      const { thread_preview, counts } = data;
      return { threads: thread_preview, counts };

      /*
      const { threadPreviews } = data
      // console.log(threadPreviews)
      states.loaded.thread_preview = [...new Set([...states.loaded.thread_preview,
        ...threadPreviews.map(d => d.thread._id)
      ])]
      // states.loaded.threads = [...new Set([...states.loaded.threads,
      //   ...threadPreviews.map(d => d.thread._id)
      // ])]
      states.loaded.admin_thread_info = [...new Set([...states.loaded.admin_thread_info,
        ...threadPreviews.map(d => d.admin_thread_info._id)
      ])]
      states.loaded.admin_event = [...new Set([...states.loaded.admin_event,
        ...threadPreviews.map(d => d.admin_event._id)
      ])]
      // console.log(states)
      inboxService.set.loaded(states.loaded)
      return threadPreviews
      // } catch (e) {
      //   console.error(e)
      //   return e
      // }
      */
    },

    /** @function
     * @async
     * @name threads.onNew
     * @memberof! module:inboxService
     * @desc Sets the listener for new thread preview models
     * @param callback {function} to receive {threadPreview[]}
     */
    onNew: (callback) => {
      inboxService.listenerForNewPushedModels.thread_preview = (data) => {
        if (data && data.length) callback(data);
      };
    },
  };
};

export default threads;
